<template>
  <div class="container-fluid">
    <table class="xz-table">
      <thead>
      <tr>
        <th class="bold">Betalingsmiddel</th>
        <th class="bold">Antall</th>
        <th class="bold"></th>
        <th class="bold">Beløp</th>
      </tr>
      </thead>
      <tbody>

      <tr>
        <td colSpan="4"><b>Kontant</b></td>
      </tr>
      <tr>
        <td>Total kontant</td>
        <td>{{ cashTotalCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(cashPaymentsTotalAmount) }}</td>
      </tr>

      <tr>
        <td colSpan="4"><b>Kredittkort</b></td>
      </tr>
      <tr>
        <td>Total kredittkort</td>
        <td>{{ cardTotalCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(cardPaymentsTotalAmount) }}</td>
      </tr>

      <tr>
        <td colSpan="4"><b>BankAxept</b></td>
      </tr>
      <tr>
        <td>Total BankAxept</td>
        <td>{{ bankAxeptTotalCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(bankAxeptPaymentsTotalAmount) }}</td>
      </tr>

      <tr v-if="loyaltyPointsCount > 0 || loyaltyPointsPaymentsTotalAmount > 0">
        <td colSpan="4"><b>Bonuspoeng</b></td>
      </tr>
      <tr v-if="loyaltyPointsCount > 0 || loyaltyPointsPaymentsTotalAmount > 0">
        <td>Total bonuspoeng</td>
        <td>{{ loyaltyPointsCount }}</td>
        <td></td>
        <td>{{ displayTwoDecimals(loyaltyPointsPaymentsTotalAmount) }}</td>
      </tr>

      <tr>
        <td class="bold">Total salg</td>
        <td class="bold">{{totalPaymentsCount}}</td>
        <td></td>
        <td class="bold">{{displayTwoDecimals(totalPayments)}}</td>
      </tr>
      </tbody>
    </table>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
import MathUtil from "@/util/MathUtil";

export default {
  props: {
    zReport: Object,
    vat: Object
  },
  computed: {
    cashTotalCount() {
      let cashPickupCount = this.zReport.cashPickupCount;
      let cashDineInCount = this.zReport.cashDineInCount;
      let cashDeliveryCount = this.zReport.cashDeliveryCount;
      return (cashPickupCount + cashDineInCount + cashDeliveryCount);
    },

    bankAxeptTotalCount() {
      let bankAxeptPickupCount = this.zReport.bankAxeptPickupCount ? this.zReport.bankAxeptPickupCount : 0;
      let bankAxeptDineInCount = this.zReport.bankAxeptDineInCount ? this.zReport.bankAxeptDineInCount : 0;
      let bankAxeptDeliveryCount = this.zReport.bankAxeptDeliveryCount ? this.zReport.bankAxeptDeliveryCount : 0;
      return (bankAxeptPickupCount + bankAxeptDineInCount + bankAxeptDeliveryCount);
    },

    cardTotalCount() {
      let cardPickupCount = this.zReport.cardPickupCount;
      let cardDineInCount = this.zReport.cardDineInCount;
      let cardDeliveryCount = this.zReport.cardDeliveryCount;
      
      // Include legacy Vipps payments as card payments
      let vippsPickupCount = this.zReport.vippsPickupCount || 0;
      let vippsDineInCount = this.zReport.vippsDineInCount || 0;
      let vippsDeliveryCount = this.zReport.vippsDeliveryCount || 0;
      let vippsDeliveryServiceCount = this.zReport.vippsDeliveryServiceCount || 0;
      
      return (cardPickupCount + cardDineInCount + cardDeliveryCount + vippsPickupCount + vippsDineInCount + vippsDeliveryCount + vippsDeliveryServiceCount);
    },

    cashPickupPaymentsTotalAmount() {
      let cashPickupPaymentsTotalAmount = this.zReport.cashPickupPaymentsTotalAmount ? this.zReport.cashPickupPaymentsTotalAmount : 0;
      return cashPickupPaymentsTotalAmount;
    },

    cashDineInPaymentsTotalAmount(){
      let cashDineInPaymentsTotalAmount = this.zReport.cashDineInPaymentsTotalAmount ? this.zReport.cashDineInPaymentsTotalAmount : 0;
      return cashDineInPaymentsTotalAmount;
    },

    cashDeliveryPaymentsTotalAmount(){
      let cashDeliveryPaymentsTotalAmount = this.zReport.cashDeliveryPaymentsTotalAmount ? this.zReport.cashDeliveryPaymentsTotalAmount : 0;
      return cashDeliveryPaymentsTotalAmount;
    },

    cashPaymentsTotalAmount() {
      return this.cashPickupPaymentsTotalAmount + this.cashDineInPaymentsTotalAmount + this.cashDeliveryPaymentsTotalAmount;
    },

    bankAxeptPaymentsTotalAmount() {
      let bankAxeptPickupPaymentsTotalAmount = this.zReport.bankAxeptPickupPaymentsTotalAmount ? this.zReport.bankAxeptPickupPaymentsTotalAmount : 0;
      let bankAxeptDineInPaymentsTotalAmount = this.zReport.bankAxeptDineInPaymentsTotalAmount ? this.zReport.bankAxeptDineInPaymentsTotalAmount : 0;
      let bankAxeptDeliveryPaymentsTotalAmount = this.zReport.bankAxeptDeliveryPaymentsTotalAmount ? this.zReport.bankAxeptDeliveryPaymentsTotalAmount : 0;
      return bankAxeptPickupPaymentsTotalAmount + bankAxeptDineInPaymentsTotalAmount + bankAxeptDeliveryPaymentsTotalAmount;
    },

    cardPaymentsTotalAmount() {
      let cardAmount = this.zReport.cardPickupPaymentsTotalAmount + this.zReport.cardDineInPaymentsTotalAmount + this.zReport.cardDeliveryPaymentsTotalAmount;
      
      // Include legacy Vipps payment amounts as card payments
      let vippsPickupAmount = this.zReport.vippsPickupPaymentsTotalAmount || 0;
      let vippsDineInAmount = this.zReport.vippsDineInPaymentsTotalAmount || 0;
      let vippsDeliveryAmount = this.zReport.vippsDeliveryPaymentsTotalAmount || 0;
      let vippsDeliveryServiceAmount = this.zReport.vippsDeliveryServicePaymentsTotalAmount || 0;
      
      return cardAmount + vippsPickupAmount + vippsDineInAmount + vippsDeliveryAmount + vippsDeliveryServiceAmount;
    },

    loyaltyPointsCount() {
      return this.zReport.loyaltyPointsCount ? this.zReport.loyaltyPointsCount : 0;
    },

    loyaltyPointsPaymentsTotalAmount() {
      return this.zReport.loyaltyPointsPaymentsTotalAmount ? this.zReport.loyaltyPointsPaymentsTotalAmount : 0;
    },

    totalPaymentsCount() {
      return this.bankAxeptTotalCount + this.cardTotalCount + this.cashTotalCount + this.loyaltyPointsCount;
    },
    totalPayments() {
      return this.bankAxeptPaymentsTotalAmount + this.cardPaymentsTotalAmount + this.cashPaymentsTotalAmount + this.loyaltyPointsPaymentsTotalAmount;
    }
  },
  methods: {
    displayTwoDecimals(num){
      if(num > 0 || num < 0){
        return MathUtil.displayTwoDecimals(num);
      }else {
        return num;
      }
    }
  }
}
</script>
